import { render, staticRenderFns } from "./defect-page.vue?vue&type=template&id=e0346c22&scoped=true&"
import script from "./defect-page.vue?vue&type=script&lang=js&"
export * from "./defect-page.vue?vue&type=script&lang=js&"
import style0 from "./defect-page.vue?vue&type=style&index=0&id=e0346c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0346c22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VProgressCircular})
